module.exports = __webpack_public_path__ + "r-v3/img/exclaim.e94a9725.svg";